import type { Distance, SpatialRectangle } from "@pdfking/math"
import type { PlotShape } from "../plot/PlotShape"

export type CompletePage = Readonly<
  {
    bleed: Distance
    shapes: PlotShape[]
  } & SpatialRectangle<Distance>
>

export type Page = Readonly<
  Partial<
    {
      bleed: Distance
      shapes: (Partial<PlotShape> & Pick<PlotShape, "enum">)[]
    } & SpatialRectangle<Distance>
  >
>
